export default "__VITE_ASSET__df6fabdd__"